<template>
  <v-card outlined class="leave-of-absence-widget">
    <v-card-title class="py-2 align-center">
      <span class="text-subtitle-2 font-weight-bold">留職停薪紀錄</span>
      <v-spacer></v-spacer>
      <v-btn
        icon
        small
        :loading="loading"
        :disabled="loading"
        @click="fetchRecords"
      >
        <v-icon small>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="pt-0">
      <v-skeleton-loader v-if="loading" type="table" class="mb-2" />

      <div v-else>
        <div v-if="error" class="red--text text-caption mb-2">
          {{ error }}
        </div>

        <div v-if="records.length === 0" class="text-center py-6 grey--text">
          無留職停薪紀錄
        </div>

        <v-simple-table v-else dense>
          <thead>
            <tr>
              <th class="text-left">開始時間</th>
              <th class="text-left">結束時間</th>
              <th class="text-left">原因</th>
              <th class="text-left" style="width: 110px">審核狀態</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in records" :key="item.id">
              <td>{{ formatDateTime(item.start_time) }}</td>
              <td>{{ formatDateTime(item.end_time) }}</td>
              <td>
                <span class="text-body-2">{{ item.reason || "-" }}</span>
              </td>
              <td>
                <v-chip
                  x-small
                  :color="statusColor(item.review_status)"
                  :text-color="statusTextColor(item.review_status)"
                  label
                >
                  {{ statusText(item.review_status) }}
                </v-chip>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { REVIEW_STATUS_TEXT, REVIEW_STATUS_COLOR } from "@/constants";

export default {
  name: "LeaveOfAbsenceWidget",
  props: {
    targetUserId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      error: "",
      records: [],
    };
  },
  computed: {
    ...mapGetters("company", ["selectedCompany"]),
    company_id() {
      return this.selectedCompany ? this.selectedCompany.id : null;
    },
  },
  watch: {
    targetUserId: {
      immediate: true,
      handler() {
        this.fetchRecords();
      },
    },
    company_id() {
      this.fetchRecords();
    },
  },
  methods: {
    async fetchRecords() {
      if (!this.targetUserId || !this.company_id) {
        this.records = [];
        return;
      }
      this.loading = true;
      this.error = "";
      try {
        const res = await this.$axios.get("/api/leave-of-absences", {
          params: {
            user_id: this.targetUserId,
            company_id: this.company_id,
            limit: 50,
            page: 1,
          },
        });
        this.records = res.data?.data || [];
      } catch (err) {
        console.error("Failed to fetch leave of absence records", err);
        this.error = err?.response?.data?.message || "無法載入留職停薪紀錄";
        this.records = [];
      } finally {
        this.loading = false;
      }
    },
    formatDateTime(value) {
      if (!value) return "-";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      return date.toLocaleString("zh-TW", {
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    statusText(code) {
      return REVIEW_STATUS_TEXT[code] || "未設定";
    },
    statusColor(code) {
      return REVIEW_STATUS_COLOR[code] || "grey lighten-1";
    },
    statusTextColor(code) {
      const color = REVIEW_STATUS_COLOR[code];
      if (!color) return "white";
      return ["amber", "yellow", "lime"].includes(color) ? "black" : "white";
    },
  },
};
</script>

<style scoped>
.leave-of-absence-widget {
  background-color: #fafafa;
}
</style>
